import { useContext } from 'react'
import { useSelector } from '@xstate/react'
import { StandardDraftsStateMachineContext } from '@/pages/standardization/draftslist/[entityId]/form'
import { standardDraftsListStateMachine } from '@isdd/metais-common/components/state-machine/standardDraftsListStateMachine'

export const useStandartDraftStateMachine = () => {
    const actorRef = useContext(StandardDraftsStateMachineContext)
    if (!actorRef) throw new Error('Missing provider')

    const snapshot = useSelector(actorRef, (s) => s)

    const currentState = snapshot.value

    const allPossibleTransitions = standardDraftsListStateMachine.states[currentState as string]?.on
        ? Object.keys(standardDraftsListStateMachine.states[currentState as string].on)
        : []

    return {
        send: actorRef.send,
        currentState,
        isInitialState: (state: string) => currentState === state,
        allPossibleTransitions,
    }
}
